'use client';

import { InverseHeader } from '@jouzen/ecom-components/layout';
import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';

import landingPageBodyGradients from '@/app/components/LandingPage/_data/landingPageBodyGradients/landingPageBodyGradients';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import StressBlog from './_components/StressBlog/StressBlog';
import StressFeatures from './_components/StressFeatures/StressFeatures';
import StressHero from './_components/StressHero/StressHero';
import StressIntegrations from './_components/StressIntegrations/StressIntegrations';
import StressJumbotron from './_components/StressJumbotron/StressJumbotron';
import StressTestimonials from './_components/StressTestimonials/StressTesimonials';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <div data-cy="stress-page">
      <InverseHeader exit>
        <StressHero />
        <RadialGradientBG
          background="sandstone-200"
          className="overflow-hidden"
          gradients={landingPageBodyGradients}
        >
          <div className="relative">
            <StressFeatures />
            <StressJumbotron />
            <StressTestimonials />
            <StressIntegrations />
          </div>
        </RadialGradientBG>
      </InverseHeader>
      <InverseHeader enter>
        <StressBlog />
      </InverseHeader>
    </div>
  );
};

export default Content;
